export const getUpdateDetailsForOnHoldBooking = (oldProducts = [], newProducts = [], forceOverride = false) => {
  const updatePrices = [];
  const updateAdditionalDetails = [];

  oldProducts?.forEach(({ passengerId, price }) => {
    const newItem = newProducts?.find(({ passengerId: newItemPassengerId }) => passengerId === newItemPassengerId);

    if (newItem) {
      if (forceOverride || newItem?.price < price) {
        updatePrices.push({
          price,
          itemRefId: Number(newItem.itemRef)
        });

        updateAdditionalDetails.push({
          itemRefId: Number(newItem.itemRef),
          key: 'original_price',
          value: String(newItem.price)
        });
      }
    }
  });

  return { updatePrices, updateAdditionalDetails };
};
